import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps } from "styled-system";

interface StyledProps extends LayoutProps, SpaceProps {
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: inline-block;
  ${space}
  ${layout}
`;

const SpannerSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="spanner-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 30 30"
        data-testid="spanner-svg"
      >
        <path
          fill="#070B16"
          d="M5.157 23.907c-.518 0-.938.42-.938.938s.42.937.938.937.937-.42.937-.937c0-.518-.42-.938-.937-.938zM25.364 13.47c-1.668 1.667-4.113 2.232-6.387 1.477l-.824-.275L6.214 26.605c-.753.752-2.068.75-2.817 0-.377-.376-.584-.877-.584-1.409s.207-1.031.584-1.408l11.944-11.94-.271-.822c-.75-2.28-.189-4.724 1.467-6.381 1.193-1.19 2.765-1.83 4.397-1.83H21L17.64 6.171l.887 5.308 5.307.884 3.36-3.357c.019 1.656-.622 3.253-1.831 4.462zm4.372-6.603c-.176-.713-.727-1.277-1.436-1.474-.709-.196-1.474.006-1.99.526l-3.438 3.435-1.9-.316-.316-1.9 3.438-3.435c.518-.521.72-1.285.522-1.992C24.418 1 23.851.45 23.134.273c-3.11-.773-6.323.12-8.586 2.384-2.205 2.204-3.082 5.354-2.386 8.395L1.409 21.8C.499 22.707 0 23.913 0 25.196c0 1.284.5 2.49 1.409 3.397C2.315 29.5 3.522 30 4.805 30c1.282 0 2.489-.5 3.398-1.407l10.742-10.738c3.035.696 6.19-.184 8.408-2.398 2.232-2.233 3.146-5.524 2.383-8.591z"
        />
      </svg>
    </StyledContainer>
  );
};

export default SpannerSVG;
